(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["babylu-promo"] && !Shopify.designMode) return;
  try {
    (function () {
      const root = document.querySelector('[data-blp]');
      if (!root) return;

      const KEY = 'babylu-promo-seen';
      let seen = false;
      try { seen = localStorage.getItem(KEY) === '1'; } catch (e) { seen = false; }
      if (seen) return;

      const panel = root.querySelector('.blp__panel');
      let lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        root.hidden = false;
        document.body.style.overflow = 'hidden';
        requestAnimationFrame(() => {
          root.classList.add('is-open');
          panel.focus();
        });
      }

      function close() {
        root.classList.remove('is-open');
        document.body.style.overflow = '';
        try { localStorage.setItem(KEY, '1'); } catch (e) { /* modo privado */ }
        setTimeout(() => { root.hidden = true; }, 220);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      root.querySelectorAll('[data-blp-close]').forEach((el) => el.addEventListener('click', close));

      document.addEventListener('keydown', (e) => {
        if (root.hidden) return;
        if (e.key === 'Escape') { close(); return; }
        if (e.key !== 'Tab') return;
        const f = panel.querySelectorAll('button, [href], input, select, textarea');
        if (!f.length) return;
        const first = f[0];
        const last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      const copyBtn = root.querySelector('[data-blp-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', async () => {
          const code = root.querySelector('[data-blp-code]').textContent.trim();
          try {
            await navigator.clipboard.writeText(code);
          } catch (e) {
            const t = document.createElement('textarea');
            t.value = code;
            document.body.appendChild(t);
            t.select();
            try { document.execCommand('copy'); } catch (e2) { /* sin portapapeles */ }
            document.body.removeChild(t);
          }
          const original = copyBtn.textContent;
          copyBtn.textContent = '¡Copiado!';
          copyBtn.classList.add('is-done');
          setTimeout(() => { copyBtn.textContent = original; copyBtn.classList.remove('is-done'); }, 2200);
        });
      }

      const delay = (parseFloat(root.dataset.blpDelay) || 6) * 1000;
      setTimeout(open, delay);
    })();
  } catch(e) { console.error(e); }
})();

})();
